const ACTIONS = {
  LOGIN_START: 'login_start',
  UPDATE_EMAIL_SUCCESSFUL: 'update_email_successful',
  UPDATE_PASSWORD_SUCCESSFUL: 'update_password_successful',
  LOGIN_COMPLETE: 'login_complete',
  LOGIN_FAILED: 'login_failed',
  LOGOUT: 'logout',
  REGISTER_START: 'register_start',
  REGISTER_COMPLETE: 'register_complete',
  REGISTER_FAILED: 'register_failed',
  AUTHENTICATE_COMPLETE: 'authenticate_complete',
  AUTHENTICATE_FAILED: 'authenticate_failed',
  UPDATE_USER_COMPLETE: 'update_user_complete',
  UPDATE_PARTNER_INFO_COMPLETE: 'update_partner_info_complete',
  UPDATE_PROFILEPIC_COMPLETE: 'update_profile_pic_complete',
  CREATE_USER_START: 'create_user_start',
  CREATE_USER_COMPLETE: 'create_user_complete',
  CREATE_USER_FAILED: 'create_user_failed',
  GET_USER_TYPES_COMPLETE: 'get_user_types_complete',
  GET_PARTNER_TYPES_COMPLETE: 'get_partner_types_complete',
  GET_ALL_CLINICS: 'get_all_clinics',
  DELETE_CLINIC: 'delete_clinic',
  GET_ALL_USERS: 'get_all_users',
  GET_ALL_PARTNERS: 'get_all_partners',
  GET_ALL_STAFF: 'get_all_staff',
  CREATE_CLINIC: 'create_clinic',
  EDIT_CLINIC: 'edit_clinic',
  GET_ALL_TREATMENTS: 'get_all_treatments',
  CREATE_TREATMENT: 'create_treatment',
  GET_ALL_CLINIC_PARTNERS: 'get_all_clinic_partners',
  ADD_TREATMENT_COLLABORATOR: 'add_treatment_collaborator',
  REMOVE_TREATMENT_COLLABORATOR: 'remove_treatment_collaborator',
  GET_ALL_TREATMENT_COLLABORATORS: 'get_all_treatment_collaborators',
  GET_USER_EVENTTYPES: 'get_user_event_types',
  GET_TREATMENT_MESSAGES: 'get_treatment_messages',
  SET_NEW_MESSAGE: 'set_new_message',
  TREATMENT_CONVERSATION: 'get_treatment_conversation',
  GET_TREATMENT_DOCUMENTS: 'get_treatment_documents',
  UPLOAD_TREATMENT_DOCUMENT: 'upload_treatment_document',
  DELETE_TREATMENT_DOCUMENT: 'delete_treatment_document',
  DELETE_TREATMENT: 'delete_treatment',
  ERASE_TREATMENT: 'erase_treatment',
  GET_ALL_TREATMENT_TRANSACTIONS: 'get_all_transactions',
  GET_ALL_USER_NOTIFICATIONS: 'get_all_user_notifications',
  GET_SCAN_FILES: 'get_scan_files',
  ADD_SCAN_FILE: 'add_scan_file',
}

export default ACTIONS;